module.exports = __webpack_public_path__ + "img/icon2.7e36b0c4.png";